import { render } from "./6.WorkSteps.vue?vue&type=template&id=54565ce8&scoped=true"
import script from "./6.WorkSteps.vue?vue&type=script&lang=js"
export * from "./6.WorkSteps.vue?vue&type=script&lang=js"

import "./6.WorkSteps.vue?vue&type=style&index=0&id=54565ce8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54565ce8"]])

export default __exports__